import { useState } from "react";
import { KeyRound, Loader2, ShieldCheck } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { errorText } from "../../lib/api";
import { FormError } from "../login/Fields";

// Proves the current 2-step factor: a 6-digit code from the app, or one unused recovery code (lost phone).
export const SecondFactorForm = ({ onConfirm, label }) => {
  const [useRecovery, setUseRecovery] = useState(false);
  const [value, setValue] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await onConfirm(useRecovery ? { recovery_code: value.trim() } : { code: value.trim() });
    } catch (err) {
      setError(errorText(err, "That code didn't work."));
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="second-factor-form">
      <div className="space-y-1.5">
        <Label htmlFor="second-factor-input">{useRecovery ? "An unused recovery code" : "The 6-digit code from your app"}</Label>
        <Input
          id="second-factor-input"
          data-testid="second-factor-input"
          autoFocus
          required
          autoComplete="one-time-code"
          inputMode={useRecovery ? "text" : "numeric"}
          maxLength={useRecovery ? 11 : 6}
          placeholder={useRecovery ? "abcde-fghjk" : "123456"}
          value={value}
          onChange={(e) => setValue(useRecovery ? e.target.value : e.target.value.replace(/\D/g, ""))}
          className="h-12 rounded-full bg-white text-center font-mono2 text-xl tracking-[0.3em]"
        />
      </div>
      <FormError text={error} />
      <Button data-testid="second-factor-submit-btn" type="submit" disabled={busy || !value || (!useRecovery && value.length !== 6)} className="h-12 w-full rounded-full font-bold gap-2">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ShieldCheck className="h-4 w-4" />} {label}
      </Button>
      <button
        type="button"
        data-testid="second-factor-recovery-toggle"
        onClick={() => { setUseRecovery((r) => !r); setValue(""); setError(""); }}
        className="inline-flex w-full items-center justify-center gap-1.5 text-sm text-[#5a554b] hover:text-[#1f1f24]"
      >
        <KeyRound className="h-3.5 w-3.5" /> {useRecovery ? "Use the code from my app" : "Lost your phone? Use a recovery code"}
      </button>
    </form>
  );
};
